module.exports = __webpack_public_path__ + "img/ic_no_work_preference.ca32cd58.svg";